import { yup } from '../../../shared/utils/yup';
import { IPortalSystem } from '../../system/types';

const yupSystem: Partial<Record<keyof IPortalSystem, yup.BaseSchema>> = {};

export const systemSchema = yup.object({}).shape(yupSystem);
